import clsx from 'clsx'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {FormComponent} from '../../../parts/crud/Form'
import Select from 'react-select'
export const LicencesForm = () => {
  return (
    <>
      <CrudProvider api='licences'>
        <FormComponent
          fetch={{tenants: 'users/tenants'}}
          redirect='/licences'
          text_modificato='Utente modificato con successo'
          text_nuovo='Utente creato con successo'
        >
          {(formik, data, remoteErrors, isEdit) => (
            <>
              <div className='row mb-6'>
                <div className='col-md-6'>
                  <div className='form-group'>
                    <label htmlFor='fk_group_id' className='required fw-bold fs-6'>
                      Tenant
                    </label>
                    <Select
                      name='fk_group_id'
                      isDisabled={isEdit}
                      options={data.tenants}
                      className={clsx('basic-multi-select ', {
                        'is-invalid': remoteErrors.fk_group_id !== undefined,
                        'is-valid': remoteErrors !== undefined && remoteErrors.fk_group_id === undefined,
                      })}
                      classNamePrefix='select'
                      onChange={(selectedOption) => formik.setFieldValue('fk_group_id', selectedOption)}
                      value={formik.values.fk_group_id}
                    />
                  </div>
                  {formik.touched.fk_group_id && formik.errors.fk_group_id ? (
                    <em className='text-danger'>{formik.errors.fk_group_id}</em>
                  ) : null}
                </div>
                <div className='col-md-6'>
                  <label htmlFor='name' className='required fw-bold fs-6'>
                    Nome lotto
                  </label>
                  <input
                    type='text'
                    className={clsx('form-control ', {
                      'is-invalid': formik.touched.name && formik.errors.name,
                      'is-valid': formik.touched.name && !formik.errors.name,
                    })}
                    id='name'
                    {...formik.getFieldProps('name')}
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <em className='text-danger'>{formik.errors.name}</em>
                  ) : null}
                </div>
              </div>
              <div className='row mb-6'>
                <div className='col-md-6'>
                  <label htmlFor='expiration' className='required fw-bold fs-6'>
                    Data di sacadenza
                  </label>
                  <input
                    type='date'
                    className={clsx('form-control ', {
                      'is-invalid': formik.touched.expiration && formik.errors.expiration,
                      'is-valid': formik.touched.expiration && !formik.errors.expiration,
                    })}
                    id='expiration'
                    {...formik.getFieldProps('expiration')}
                  />
                  {formik.touched.expiration && formik.errors.expiration ? (
                    <em className='text-danger'>{formik.errors.expiration}</em>
                  ) : null}
                </div>

               

                <div className='col-md-6'>
                  <label htmlFor='tokens' className='required fw-bold fs-6'>
                    Numero di licenze
                  </label>
                  <input
                    type='number'
                    disabled={isEdit}
                    className={clsx('form-control ', {
                      'is-invalid': formik.touched.tokens && formik.errors.tokens,
                      'is-valid': formik.touched.tokens && !formik.errors.tokens,
                    })}
                    id='tokens'
                    {...formik.getFieldProps('tokens')}
                  />
                  {formik.touched.tokens && formik.errors.tokens ? (
                    <em className='text-danger'>{formik.errors.tokens}</em>
                  ) : null}
                </div>
              </div>
            </>
          )}
        </FormComponent>
      </CrudProvider>
    </>
  )
}
